import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { redirectLegacyBilligEl } from "@/lib/legacyRedirects";
import { notFoundUnlessRedirected } from "@/lib/slugGuards";

const NotFound = lazy(() => import("@/pages/NotFound"));

/**
 * Fångar alla adresser som inte matchar någon rutt. Finns en aktiv
 * omdirigering i databasen skickas besökaren vidare med 301, annars
 * visas 404-sidan (som loggar träffen).
 */
export const Route = createFileRoute("/$")({
  head: () => seoHead("/$"),
  beforeLoad: async ({ location }) => {
    const path = location.pathname.replace(/\/+$/, "") || "/";
    // Kända gamla URL-mönster (t.ex. billig-el-sidorna) omdirigeras alltid,
    // även utan databasträff.
    redirectLegacyBilligEl(path);
    await notFoundUnlessRedirected(path);
  },
  component: () => <NotFound />,
  notFoundComponent: () => <NotFound />,
});
